<page-header [showCloseIcon]="false" />

<h2 class="cmc-section-title">{{ 'board.header_leading_board' | translate }}</h2>
<div class="cmc-detail-grid m-b-32">
  @for (lb of leadingBoard(); track lb.id) {
      <div class="cmc-person-card" [class.cmc-person-card--vacant]="!lb.person">
        <img class="cmc-person-card__photo" alt=""
          [src]="!lb.person ? 'assets/images/theme/board/unbesetzt.png' : (lb.photoUrl ? serverUrl + '/' + lb.photoUrl : 'assets/images/theme/board/no_photo.png')">
        <div class="min-w-0">
          <h3 class="cmc-person-card__name">
            {{ lb.person ? lb.fullname : ('board.text_unoccupied' | translate) }}
          </h3>
          <div class="cmc-person-card__role">
            <mat-icon>assignment_ind</mat-icon>
            {{ lb.role.name }}
          </div>
        </div>
      </div>
  }
</div>

<h2 class="cmc-section-title">{{ 'board.header_non_leading_board' | translate }}</h2>
<div class="cmc-detail-grid">
  @for (nb of nonLeadingBoard(); track nb.id) {
      <div class="cmc-person-card" [class.cmc-person-card--vacant]="!nb.person">
        <img class="cmc-person-card__photo" alt=""
          [src]="!nb.person ? 'assets/images/theme/board/unbesetzt.png' : (nb.photoUrl ? serverUrl + '/' + nb.photoUrl : 'assets/images/theme/board/no_photo.png')">
        <div class="min-w-0">
          <h3 class="cmc-person-card__name">
            {{ nb.person ? nb.fullname : ('board.text_unoccupied' | translate) }}
          </h3>
          <div class="cmc-person-card__role">
            <mat-icon>assignment_ind</mat-icon>
            {{ nb.role.name }}
          </div>
        </div>
      </div>
  }
</div>
